import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { APP_CONFIG } from "../../../core/config/app-config";
import { SessionFacade } from "../../authentication";
import { CredentialStore } from "../../authentication/data-access/credential.store";

@Injectable({ providedIn: "root" })
export class ConferenceRoomApiService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(APP_CONFIG);
    private readonly session = inject(SessionFacade);
    private readonly credentials = inject(CredentialStore);

    create(): Observable<string> {
        const roomId = crypto.randomUUID();
        const owner = this.session.user()?.username ?? "";
        const params = new HttpParams().set("owner", owner);
        const signalingBase = this.config.realtimeBaseUrl + this.config.realtimePath.replace(/\/socket\.io\/?$/, "");
        let headers = new HttpHeaders({ "x-gem-api-key": this.config.apiKey ?? "" });
        const token = this.credentials.readTokens()?.accessToken;
        if (token) headers = headers.set("x-auth-token", token);
        if (this.config.webVersion) headers = headers.set("x-version-web", this.config.webVersion);
        return this.http.get<{ roomId: string }>(`${signalingBase}/confroom/${roomId}`, { params, headers }).pipe(map((response) => response.roomId));
    }
}
